import { Dialog, DialogActions, DialogContent, DialogTitle, makeStyles } from '@material-ui/core';
import {
  Card,
  CardContent,
  Typography,
  Button,
  ListItem,
  Divider,
  Box,
} from '@mui/material';
import { benefits, MODIFICATION, PURCHASE, RENEWAL } from './helpers';
import { consentDowngrade, unsubscribePlan } from '../../services/payments';
import { useState } from 'react';
const scrollsSettings = {
  overflow: 'scroll',
  height: '50vh',
  overflowX: 'hidden',
};

const webkitScrollbar = {
  background: 'white',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '#beb1b18f',
  width: '9px',
};

const webkitscrollbarTrack = {
  background: '#dfdfe957',
};

const useStyles = makeStyles(theme => ({
  listModules: {
    border: '1px solid #b5b5b578',
    padding: '5px',
    ...scrollsSettings,
    '&::-webkit-scrollbar': {
      //son los estilos de las barras scroll en una variable.
      ...webkitScrollbar,
    },
    '&::-webkit-scrollbar-track': {
      //son los estilos de las barras scroll en una variable.
      ...webkitscrollbarTrack,
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.primary.main,
    },
    '@media (max-width: 960px)': {
      width: '100%',
    },
  },
  containerCard: {
    width: '500px',
    maxWidth: '500px',
    position: 'relative',
    '@media (max-width: 1400px)': {
      width: '31%',
    },
    '@media (max-width: 940px)': {
      width: '46%',
    },
    '@media (max-width: 540px)': {
      width: '100%',
    },
  },
  blueBarTop: {
    position: 'absolute',
    width: '100%',
    zIndex: 1,
  },
  mainContent: {
    minHeight: '220px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}));

export default function CardComponent({
  userInfo,
  plan,
  handleOpenCloseModalPay,
  currency,
  disabled,
  setPurchaseType,
  purchases,
  lastPurchase,
  notificationsPendings,
  setOpenUnsuscribedModal,
  setMsg,
  hasPurchases,
  setClose
}) {
  const classes = useStyles();
  const planBenefits = benefits.find(benefit => benefit.plan === plan?.name);
  const RECURRENT = 'Recurrente';
  const [isUnsuscribeDialogOpen, setIsUnsuscribeDialogOpen] = useState(false);
  const hasNoRemainingDays = userInfo?.dias_restantes <= 0 && lastPurchase?.tipo_ultima_compra !== RECURRENT;
  const [isPlanFreeDialogOpen, setIsPlanFreeDialogOpen] = useState(false);
  const [isOnFreePlan, setIsOnFreePlan] = useState(false);

  const actualPlan = () => {
    if (userInfo?.plan_actual === plan?.name) {
      return true;
    } else {
      return false;
    }
  };

  const getAnnualPrice = monthlyPrice => {
    let anualPrice = (monthlyPrice * 11) / 12;
    return anualPrice.toFixed(2);
  };

  const formatPrice = price => {
    if (currency === 'ARS') {
      return `$ ${price} ARS`;
    } else {
      return `U$S ${price}`;
    }
  };

  const handleButton = async (plan, type) => {
    if (plan.name === 'Gratuito') {
      setIsPlanFreeDialogOpen(true);
    } else {
      plan.newPrice = plan.price;
      setPurchaseType(type);
      handleOpenCloseModalPay(plan);
    }
  };

  const unsubscribe = async () => {
    try {
      await unsubscribePlan(notificationsPendings?.last_compra);
      setOpenUnsuscribedModal(true);
      setIsUnsuscribeDialogOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFreePlan = async () => {
    try {
      await consentDowngrade(true);
      setIsPlanFreeDialogOpen(false);
      setIsOnFreePlan(true);
    } catch (error) {
      setIsPlanFreeDialogOpen(false);
      console.error(error);
      setMsg({
        type: 'error',
        msg: 'Hubo un error al solicitar el cambio de plan.',
      })
      setClose(true);
    }
  }

  return (
    <>
      <Card
        key={plan?.id}
        className={classes.containerCard}
        sx={{
          margin: '10px',
          border: disabled
            ? '1px solid #808080'
            : actualPlan()
              ? '1px solid #78b0ff'
              : '1px solid #ccc',
          borderRadius: '8px',
        }}
      >
        {/* Linea superior gradient */}
        <Box
          className={classes.blueBarTop}
          style={{
            height: actualPlan() ? '' : '7px',
            background: disabled
              ? '#808080'
              : 'linear-gradient(45deg, #1E3A8A, #3B82F6, #60A5FA)',
          }}
        >
          <Box ml={1} fontSize={12} color={'white'} p={0.5} fontWeight={'bold'}>
            {actualPlan() ? 'Plan actual' : ''}
          </Box>
        </Box>

        {/* Titulo */}
        <Box mt={1} backgroundColor="#f5f5f582" p={3}>
          <Box fontSize={15} fontWeight="bold" color="#5b6065">
            Plan
          </Box>
          <Box fontSize={19} fontWeight="bold" color="#4f4f4f">
            {plan?.name}
          </Box>
        </Box>

        {/* Contenido inicial */}
        <CardContent className={classes.mainContent}>
          <Box>
            {planBenefits?.headers.map(elem => {
              return (
                <Box key={elem} maxWidth={'320px'}>
                  <Box ml={1}>
                    <ListItem
                      sx={{
                        fontSize: '13px',
                        padding: 0,
                        marginBottom: '8px',
                        color: '#808080',
                        fontWeight: 'bold',
                      }}
                    >
                      {elem}
                    </ListItem>
                  </Box>
                </Box>
              );
            })}
          </Box>
          {/* <Divider /> */}
          <Box>
            <Typography variant="h5">{`${formatPrice(
              Number(plan?.price).toLocaleString('es-AR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              })
            )}/mes`}</Typography>
            <Typography color="#808080" fontSize="15px" variant="body2">
              {` ${formatPrice(
                Number(getAnnualPrice(plan?.price)).toLocaleString('es-AR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                })
              )}/mes`}{' '}
              si elige pagar por un año
            </Typography>
          </Box>
        </CardContent>

        {/* Botones */}

        <Box pr={2} pl={2}>
          {/* SOLO si no hay plan */}
          {!actualPlan() ? (
            <Button
              onClick={() => handleButton(plan, PURCHASE)}
              fullWidth
              color={disabled ? 'inherit' : 'primary'}
              disabled={disabled}
              variant="contained"
              sx={{ fontWeight: 'bold', textTransform: 'none' }}
            >
              Elegir plan
            </Button>
          ) : (
            <Box display="flex" flexDirection="column" gap={1}>
              {/* Modificar SOLO si todavía tiene días restantes */}
              {!hasNoRemainingDays && (
                <Button
                  onClick={() => handleButton(plan, MODIFICATION)}
                  fullWidth
                  color={disabled ? 'inherit' : 'primary'}
                  disabled={disabled}
                  variant="contained"
                  sx={{ fontWeight: 'bold', textTransform: 'none' }}
                >
                  Modificar plan
                </Button>
              )}

              {/* Si NO tiene pagos y el plan venció => Renovar (aunque no haya pagos) */}
              {hasNoRemainingDays && hasPurchases && lastPurchase?.tipo_ultima_compra !== RECURRENT && (
                <Button
                  onClick={() => handleButton(plan, RENEWAL)}
                  fullWidth
                  color={disabled ? 'inherit' : 'primary'}
                  disabled={disabled}
                  variant="contained"
                  sx={{ fontWeight: 'bold', textTransform: 'none' }}
                >
                  Renovar plan
                </Button>
              )}

              {/* Elegir plan si nunca compró */}
              {hasNoRemainingDays && !hasPurchases && (
                <Button
                  onClick={() => handleButton(plan, PURCHASE)}
                  fullWidth
                  color={disabled ? 'inherit' : 'primary'}
                  disabled={disabled}
                  variant="contained"
                  sx={{ fontWeight: 'bold', textTransform: 'none' }}
                >
                  Elegir plan
                </Button>
              )}

              {/* Acciones de recurrente */}
              {lastPurchase?.tipo_ultima_compra === RECURRENT &&
                (lastPurchase?.compra_recurrente_cancelada ? (
                  <Button
                    onClick={() => handleButton(plan, 'REACTIVATE')}
                    fullWidth
                    color={disabled ? 'inherit' : 'primary'}
                    disabled={disabled}
                    variant="contained"
                    sx={{ fontWeight: 'bold', textTransform: 'none' }}
                  >
                    Reactivar suscripción
                  </Button>
                ) : (
                  <Button
                    onClick={() => setIsUnsuscribeDialogOpen(true)}
                    color="error"
                    disabled={disabled || hasNoRemainingDays}
                    variant="contained"
                    sx={{
                      fontWeight: 'bold',
                      textTransform: 'none',
                      fontSize: '0.85rem',
                      padding: '4px 12px',
                      width: 'auto',
                      minWidth: '120px',
                    }}
                  >
                    Cancelar débito automático
                  </Button>
                ))}
            </Box>
          )}
        </Box>




        {/* Linea inferior division */}
        <Box pr={2} pl={2} pt={2}>
          <Divider />
        </Box>

        {/* Que incluye */}
        <CardContent>
          <Typography
            color="#656363"
            fontSize={14}
            variant="subtitle1"
            gutterBottom
          >
            <strong>QUÉ INCLUYE</strong>
          </Typography>
          <Box
            className={classes.listModules}
            overflow={'auto'}
            maxHeight={'200px'}
            style={{
              overflowX: 'hidden',
              overflowY: disabled ? 'hidden' : 'visible',
            }}
          >
            {planBenefits?.modules.map((module, index) => (
              <Typography key={index} color="#656363" variant="body2">
                <strong dangerouslySetInnerHTML={{ __html: module }}></strong>
              </Typography>
            ))}
          </Box>
        </CardContent>
      </Card>
      <Dialog
        open={isUnsuscribeDialogOpen}
        onClose={() => setIsUnsuscribeDialogOpen(false)}
        aria-labelledby="unsubscribe-dialog-title"
        aria-describedby="unsubscribe-dialog-description"
      >
        <DialogTitle id="unsubscribe-dialog-title">
          ¿Cancelar la renovación automática del plan?
        </DialogTitle>
        <DialogContent id="unsubscribe-dialog-description">
          En caso de confirmar, se cancelará la renovación automática.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setIsUnsuscribeDialogOpen(false)}
            variant="text"
          >
            Cancelar
          </Button>
          <Button
            onClick={unsubscribe}
            variant="contained"
            color="primary"
            autoFocus
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isPlanFreeDialogOpen}
        onClose={() => setIsPlanFreeDialogOpen(false)}
        aria-labelledby="unsubscribe-dialog-title"
        aria-describedby="unsubscribe-dialog-description"
      >
        <DialogTitle id="unsubscribe-dialog-title">
          ¿Estás seguro que deseas cambiarte al plan Gratuito?
        </DialogTitle>
        <DialogContent id="unsubscribe-dialog-description">
          En caso de confirmar, al finalizar tu periodo actual, se cambiará tu plan al plan Gratuito.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setIsPlanFreeDialogOpen(false)}
            variant="text"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleFreePlan}
            variant="contained"
            color="primary"
            autoFocus
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isOnFreePlan}
        onClose={() => setIsOnFreePlan(false)}
        aria-labelledby="unsubscribe-dialog-title"
        aria-describedby="unsubscribe-dialog-description"
      >
        <DialogTitle id="unsubscribe-dialog-title">
          Operación exitosa
        </DialogTitle>
        <DialogContent id="unsubscribe-dialog-description">
          Al finalizar tu periodo actual, se cambiará tu plan al plan Gratuito.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setIsOnFreePlan(false)}
            variant="text"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
